import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('column').set({
        label: 'Flex-Spalte',
        category: blockCategories.layout,
        content: {
            type: 'column',
            classes: ['tw-col', 'flex-1', 'p-4'],
        },
        media: `
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="columns" class="svg-inline--fa fa-columns fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"></path></svg>
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('column', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Column',
                draggable: '.tw-row',
                droppable: true,
                // resizable: {
                //     updateTarget: (el, rect, opt) => {},
                // },
                traits: [].concat(defaultModel.prototype.defaults.traits),
            }),
        },
        isComponent(el) {
            let match = false;
            if (el && el.classList) {
                el.classList.forEach(function (klass) {
                    if (klass == 'tw-col' || klass.match(/^tw-col-/)) {
                        match = true;
                    }
                });
            }
            if (match) return { type: 'column' };
        },
        view: defaultView,
    });
};
